import { useEffect } from "react";
import "@/App.css";
import { BrowserRouter } from "react-router-dom";
import Lenis from "lenis";
import Nav from "@/components/Nav";
import Hero from "@/components/Hero";
import SeriesTeaser from "@/components/SeriesTeaser";
import MarqueeBand from "@/components/MarqueeBand";
import Story from "@/components/Story";
import Showcase from "@/components/Showcase";
import Reviews from "@/components/Reviews";
import NewsletterSignup from "@/components/NewsletterSignup";
import Finale from "@/components/Finale";
import Footer from "@/components/Footer";

function App() {
  useEffect(() => {
    const reduced = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
    if (reduced) return;
    const lenis = new Lenis({ lerp: 0.09, wheelMultiplier: 1 });
    window.__lenis = lenis;
    let raf;
    const loop = (t) => {
      lenis.raf(t);
      raf = requestAnimationFrame(loop);
    };
    raf = requestAnimationFrame(loop);
    return () => {
      cancelAnimationFrame(raf);
      lenis.destroy();
      window.__lenis = null;
    };
  }, []);

  return (
    <BrowserRouter>
      <div className="relative bg-[#050505] text-white min-h-screen">
        <div className="grain-overlay" aria-hidden="true" />
        <Nav />
        <main>
          <Hero />
          <SeriesTeaser />
          <MarqueeBand />
          <Story />
          <Showcase />
          <Reviews />
          <NewsletterSignup />
          <Finale />
        </main>
        <Footer />
      </div>
    </BrowserRouter>
  );
}

export default App;
